module.exports = __webpack_public_path__ + "img/facebook.5849af67.png";